const events = {
  // Page titles
  pageTitle: 'Paramètres d\'événement | WedBox',
  settingsTitle: 'Paramètres de l\'événement',
  settingsDescription: 'Gérez les détails de votre événement',
  
  // Existing basic fields
  title: "Mes événements",
  myEvents: "Mes événements",
  description: "Créez et gérez vos événements",
  createEvent: "Créer un événement",
  createNew: "Créer un nouveau",
  currentEvent: "Événement actuel",
  noEvents: "Aucun événement",
  addFirstEvent: "Créez votre premier événement",
  createFirstEvent: "Créez votre premier événement",
  eventCreated: "Événement créé avec succès",
  eventUpdated: "Événement mis à jour",
  eventDeleted: "Événement supprimé",
  selectEventType: "Sélectionnez le type d'événement",
  date: "Date",
  location: "Lieu",
  guestCount: "Nombre d'invités",
  budget: "Budget",
  status: "Statut",
  active: "Actif",
  draft: "Brouillon",
  completed: "Terminé",
  cancelled: "Annulé",
  editEvent: "Modifier l'événement",
  deleteEvent: "Supprimer l'événement",
  confirmDelete: "Êtes-vous sûr de vouloir supprimer cet événement ?",
  yes: "Oui",
  no: "Non",
  save: "Enregistrer",
  cancel: "Annuler",
  close: "Fermer",
  switch: "Changer",
  switchEvent: "Changer d'événement",
  switchedTo: "Passé à l'événement",
  currentlyActive: "Actuellement actif",
  searchEvents: "Rechercher des événements",
  noEventsFound: "Aucun événement trouvé",
  manage: "Gérer",
  yourEvents: "Vos événements",
  advancedView: "Vue avancée",
  basicView: "Vue basique",

  // Bulk actions
  bulkActions: {
    title: "Actions groupées",
    selectAll: "Tout sélectionner",
    selected: "sélectionné(s)",
    delete: "Supprimer",
    archive: "Archiver",
    export: "Exporter",
    duplicate: "Dupliquer",
    processing: "Traitement en cours...",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer les événements sélectionnés ?",
    description: "Gérez plusieurs événements à la fois"
  },

  // Subscription info
  subscriptionInfo: {
    free: {
      title: "Plan Gratuit",
      description: "Idéal pour commencer"
    },
    essential: {
      title: "Plan Essentiel",
      description: "Pour les petits événements"
    },
    pro: {
      title: "Plan Pro",
      description: "Pour les grands événements"
    }
  },

  dashboard: {
    subtitle: "Vue d'ensemble"
  },

  maxEventsReached: "Nombre maximum d'événements atteint",

  // Event types
  eventTypes: {
    wedding: "Mariage",
    engagement: "Fiançailles",
    birthday: "Anniversaire",
    babyShower: "Baby shower",
    baptism: "Baptême",
    reunion: "Réunion",
    corporate: "Événement d'entreprise",
    other: "Autre"
  },

  // Form sections
  form: {
    eventDetails: "Détails de l'événement",
    basicInfo: "Informations de base",
    eventName: "Nom de l'événement",
    eventType: "Type d'événement",
    eventDate: "Date de l'événement",
    eventLocation: "Lieu de l'événement",
    partners: "Partenaires / Personnes principales",
    partner1: "Premier partenaire / Personne principale", 
    partner2: "Second partenaire (optionnel)",
    firstName: "Prénom",
    lastName: "Nom de famille",
    placeholders: {
      eventName: 'Ex: Mariage de Marie et Pierre',
      eventLocation: 'Ex: Château de Versailles, Paris',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
    },
  },

  // Actions
  actions: {
    create: "Créer",
    edit: "Modifier",
    delete: "Supprimer",
    duplicate: "Dupliquer",
    share: "Partager",
    setDefault: "Définir par défaut",
    selectEvent: "Sélectionner un événement",
  },

  // Date formatting
  dateFormat: {
    notSpecified: 'Non spécifiée',
    invalid: 'Date invalide',
  },

  // Card details
  details: {
    title: 'Détails de l\'événement',
    id: 'ID:',
    eventCount: '{{count}} événements au total',
    singleEvent: '1 événement',
  },

  // Empty state
  empty: {
    noEventSelected: 'Aucun événement sélectionné',
    selectEventDescription: 'Veuillez sélectionner un événement pour accéder à ses paramètres.',
  },

  // Success messages
  success: {
    title: 'Succès',
    eventUpdated: 'Événement mis à jour avec succès',
  },

  // Error messages
  errors: {
    title: 'Erreur',
    updateFailed: 'Échec de la mise à jour de l\'événement normal',
    updateError: 'Erreur lors de la mise à jour',
    deleteFailed: 'Échec de la suppression de l\'événement normal',
    deleteError: 'Erreur lors de la suppression',
  },

  // Delete confirmation
  deleteConfirmation: {
    title: 'Supprimer l\'événement',
    description: 'Êtes-vous sûr de vouloir supprimer l\'événement "{{eventName}}" ? Cette action est irréversible et toutes les données associées seront supprimées.',
    confirm: 'Supprimer',
    cancel: 'Annuler',
  },

  // Existing features
  features: {
    aiAssistant: 'Assistant IA',
    aiAssistantDesc: 'Obtenez des suggestions personnalisées et une aide intelligente.',
    taskManagement: 'Gestion des tâches',
    taskManagementDesc: 'Organisez et suivez toutes vos tâches d\'événement.',
    budgetPlanning: 'Planification budgétaire',
    budgetPlanningDesc: 'Gérez votre budget avec des outils de suivi détaillés.',
    guestManagement: 'Gestion des invités',
    guestManagementDesc: 'Organisez votre liste d\'invités et leurs réponses.',
    vendorCoordination: 'Coordination fournisseurs',
    vendorCoordinationDesc: 'Trouvez et gérez vos prestataires facilement.',
    timelineTracking: 'Suivi chronologique',
    timelineTrackingDesc: 'Visualisez et planifiez votre chronologie d\'événement.',
    collaborativeTools: 'Outils collaboratifs',
    collaborativeToolsDesc: 'Travaillez ensemble avec votre équipe et vos proches.',
    documentSharing: 'Partage de documents',
    documentSharingDesc: 'Partagez et organisez tous vos documents importants.',
    mobileSynchronization: 'Synchronisation mobile',
    mobileSynchronizationDesc: 'Accédez à vos données partout avec la sync cloud.',
    customTemplates: 'Modèles personnalisés',
    customTemplatesDesc: 'Créez et utilisez des modèles adaptés à vos besoins.',
    realTimeNotifications: 'Notifications temps réel',
    realTimeNotificationsDesc: 'Restez informé des mises à jour importantes.',
    advancedReporting: 'Rapports avancés',
    advancedReportingDesc: 'Analysez vos données avec des rapports détaillés.',
    duplicateDetection: 'Détection de doublons',
    duplicateDetectionDesc: 'Identifie les événements similaires basés sur le nom, type et date.'
  },

  // Test page translations
  testPage: {
    title: "🧪 Page de Test Firebase Functions",
    firebaseTest: {
      title: "Test Fonction Firebase",
      description: "Testez la connectivité avec les fonctions Firebase avant d'essayer la suppression de compte.",
      button: "Tester la fonction Firebase",
      result: "Résultat",
      userNotConnected: "❌ Utilisateur non connecté",
      testing: "🧪 Test en cours...",
      success: "✅ Test réussi",
      error: "❌ Erreur",
      unknownError: "Erreur inconnue",
    },
    instructions: {
      title: "📋 Instructions",
      step1: "Cliquez sur \"Tester la fonction Firebase\" ci-dessus",
      step2: "Si le test réussit, allez dans Paramètres → Compte",
      step3: "Essayez de supprimer votre compte",
      step4: "La fonction backend devrait fonctionner sans demander de mot de passe",
    },
    messages: {
      eventCreated: "✅ Événement créé avec succès ! ID: {{eventId}}",
      tasksGenerated: "🎯 {{count}} tâches générées automatiquement !",
      noTasksFound: "⚠️ Aucune tâche trouvée. Utilisez le bouton de débogage pour générer manuellement.",
      errorLoadingTasks: "❌ Erreur lors du chargement des tâches",
      errorCreatingEvent: "❌ Erreur",
      waitingForTasks: "🔄 Attente de 3 secondes avant de charger les tâches...",
      loadingTasks: "🔍 Chargement des tâches pour l'événement:",
      tasksReloaded: "🔄 Rechargé: {{count}} tâches trouvées",
      errorReloadingTasks: "❌ Erreur lors du rechargement des tâches",
      debuggingGeneration: "🔧 Débogage de la génération de tâches...",
      manualGenerationComplete: "✅ Génération manuelle terminée",
      debugError: "❌ Erreur de débogage",
      testingExistingEvent: "🧪 Test avec événement existant...",
      eventNotFound: "❌ Événement non trouvé",
      eventFound: "📋 Événement trouvé",
      eventDate: "📅 Date",
      eventCountry: "🌍 Pays",
      notSpecified: "Non spécifié",
      existingTasks: "📊 Tâches existantes",
      generatingTasks: "🔧 Génération des tâches (si nécessaire)...",
      generationComplete: "✅ Génération terminée",
      newTasks: "📊 Nouvelles tâches",
      testError: "❌ Erreur de test",
      generatingForAllEvents: "🔄 Génération des tâches pour tous les événements existants...",
      noEventsFound: "📋 Aucun événement trouvé",
      eventsFound: "📊 {{count}} événement(s) trouvé(s)",
      processingEvent: "🔧 Traitement",
      generatingTasksFor: "🎯 Génération des tâches pour",
      tasksGeneratedFor: "✅ {{count}} tâches générées pour",
      eventAlreadyHasTasks: "✅ {{name}} a déjà {{count}} tâches",
      errorProcessingEvent: "❌ Erreur pour",
      processingComplete: "🎉 Traitement terminé: {{processed}} événements traités, {{generated}} nouvelles tâches générées",
      globalError: "❌ Erreur globale",
    },
    eventTypes: {
      wedding: "Mariage",
      birthday: "Anniversaire",
      engagement: "Fiançailles",
      babyShower: "Baby Shower",
      baptism: "Baptême",
      other: "Autre",
    },
  },
};

export default events;